/* eslint-disable react/prop-types */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
var RecommendationIcon = function (_a) {
    var _b = _a.size, size = _b === void 0 ? 16 : _b, _c = _a.color, color = _c === void 0 ? '#fff' : _c, _d = _a.strokeWidth, strokeWidth = _d === void 0 ? 2 : _d, _e = _a.styles, styles = _e === void 0 ? {} : _e, viewBox = _a.viewBox;
    return (React.createElement("svg", { style: __assign({ width: size }, styles), viewBox: viewBox || '0 0 24 24' },
        React.createElement("g", { transform: "matrix(1,0,0,1,0,0)" },
            React.createElement("path", { d: "M5.25,21.751a6,6,0,0,1,1.558.23l3.634,1.038a6,6,0,0,0,1.647.231h4.885a6,6,0,0,0,5.97-5.4l.3-5.1a4.5,4.5,0,0,0-3.4-4.594l-1.455-.318A1.5,1.5,0,0,1,17.25,6.382V3a2.25,2.25,0,0,0-4.5,0V4.554a7.5,7.5,0,0,1-7.5,7.5Z", fill: "none", stroke: color, strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: strokeWidth }),
            React.createElement("path", { d: "M0.75 9.75H5.25V23.25H0.75z", fill: "none", stroke: color, strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: strokeWidth }))));
};
export default RecommendationIcon;
